import { render } from "./CartBig.vue?vue&type=template&id=a50a80b6"
import script from "./CartBig.vue?vue&type=script&lang=js"
export * from "./CartBig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__